import { createFileRoute, redirect } from '@tanstack/react-router'

import { DigitalProductPartners } from '@/features/partners'
import {
  buildPartnerPageHref,
  legacyPartnerParam,
  validatePartnerLegacySearch,
  type PartnerLegacySearch
} from '@/features/partners/lib/partnerRoute'
import { useEventSlug } from '@/shared/hooks/useEventSlug'

export const Route = createFileRoute('/_event/parceiros/')({
  validateSearch: (search: Record<string, unknown>): PartnerLegacySearch =>
    validatePartnerLegacySearch(search),
  // `/parceiros?partner=` foi a URL do parceiro por uma sprint e ainda circula
  // em links e QR codes. Ela continua entrando, mas o destino é a página do
  // parceiro — o show tem conteúdo demais para caber num bottom sheet.
  beforeLoad: ({ search }) => {
    const partner = legacyPartnerParam(search)
    if (!partner) return

    throw redirect({ href: buildPartnerPageHref(partner), replace: true })
  },
  component: DigitalProductPartnersPage
})

function DigitalProductPartnersPage() {
  // The legacy partners list builds its API path from props.digitalProductId
  // (getConfig(props)); without it the path becomes `.../undefined/partners`,
  // which useRecords disables — leaving the screen stuck on "Carregando...".
  const digitalProductId = useEventSlug()

  return <DigitalProductPartners digitalProductId={digitalProductId} />
}
